<template>
  <report-data-provider :requiredReports="requiredReports" v-model="reports" v-slot:default="{ loading, error, retry }">
    <card-loading v-if="loading" />
    <card-reload v-else-if="error" @reload="retry()"/>
    <critical-card v-else :data="cardData"/>
  </report-data-provider>
</template>

<script>
import ReportDataProvider from '@/components/dashboard/ReportDataProvider.vue'
import CardLoading from '@/components/dashboard/CardLoading.vue'
import CardReload from '@/components/dashboard/CardReload.vue'
import CriticalCard from '@/components/dashboard/efficiency/cards/CriticalCard.vue'
import { senseMap } from '@/plugins/colors.js'

export default {
  components: {
    ReportDataProvider,
    CardLoading,
    CardReload,
    CriticalCard
  },
  data () {
    return {
      requiredReports: ['criticalIndicators'],
      reports: null
    }
  },
  computed: {
    cardData () {
      const { criticalIndicators } = this.reports
      return {
        title: 'Отказ организатора от продолжения торгов',
        unit: 'шт.',
        max: {
          value: criticalIndicators.orgRejectMax,
          style: { color: senseMap.max }
        },
        avg: {
          value: criticalIndicators.orgRejectAvg,
          style: { color: senseMap.average }
        },
        percent: {
          value: criticalIndicators.orgRejectPercent
        }
      }
    }
  }
}
</script>
